<template lang="html">
  <div class="start-xs">
    <pl-dialog
      :title="optionalText"
      @close="close"
      :size="'relative'"
      :disableOutsideClick="true"
    >
      <body class="px-7 pt-7 pb-4 flex-grow overflow-y-auto">
        <div class="flex justify-center mb-4">
          <i class="fa-solid fa-circle-exclamation text-red-500 text-4xl"></i>
        </div>
        <div class="flex justify-center mb-8">
          <p class="text-center px-24">{{ subHeader }}</p>
        </div>
        <div class="px-12">
          <input
            v-model="confirm"
            @keyup.enter="submitConfirm"
            class="bg-input text-sm text-gray-600 flex-grow border border-solid focus:border-red-500 px-3 py-2 w-full rounded placeholder-gray-400"
            :placeholder="labelText"
          />
          <p
            :class="errorMessage !== 'No Error' ? 'text-red-500' : 'text-white'"
            class="text-xs ml-2 mt-1"
          >
            {{ errorMessage }}
          </p>
        </div>
      </body>
      <footer class="flex my-8 center items-center">
        <button
          @click="close"
          class="bg-gray-200 hover:bg-gray-300 py-2 px-5 text-gray-700 rounded mr-3"
        >
          Cancel
        </button>
        <button
          @click="submitConfirm"
          class="py-2 px-5 text-white rounded"
          :class="confirmColor"
        >
          {{ submitButton }}
        </button>
      </footer>
    </pl-dialog>
  </div>
</template>

<script>
  import { EventBus } from 'utils/event-bus';
  export default {
    data() {
      return {
        confirm: '',
        errorMessage: 'No Error',
      };
    },
    watch: {
      confirm: function () {
        if (this.errorMessage !== '' && this.confirm === '')
          this.errorMessage = 'No Error';
      },
    },
    props: {
      optionalText: {
        type: String,
        default: '',
      },
      labelText: {
        type: String,
        default: 'Please type "confirm" to delete this item',
      },
      header: {
        type: String,
        default: 'Are you sure you want to delete this',
      },
      submitButton: {
        type: String,
        default: 'Delete',
      },
      subHeader: {
        type: String,
        default: null,
      },
      confirmColor: {
        type: String,
        default: 'bg-red-500 hover:bg-red-600 text-white',
      },
    },
    methods: {
      submitConfirm() {
        if (this.confirm === 'confirm') {
          this.errorMessage = '';
          this.confirm = '';
          this.$emit('actionConfirmed');
          this.close();
        } else {
          this.errorMessage = 'Incorrect spelling. Please try again!';
          const toast = {
            type: 'Error',
            message: 'Please type in "confirm" to continue!',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
        }
      },
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
</style>



// WEBPACK FOOTER //
// dialogDeleteConfirm.vue?c4207f86